<template>
    <div>
       <h2> 🏎️ </h2>
       <button>Go!</button>
    </div>
</template>
<script>
</script>
